<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>

            <CRow>
              <CCol col="8" style="text-align: start ;padding:0px 20px 0 20px ">
                <strong>{{ $t('customerBill') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: end ;padding:0px 20px 0 20px ">

                <CButton
                    class="mr-1"
                    size="sm"
                    @click="print_with_header_title_height(body_id,header_id,footer_id,selected_person_name,100,100)"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>
              </CCol>

            </CRow>
          </CCardHeader>
          <br>

          <CRow>



            <CCol>
              <treeselect
                  v-model="selected_person"
:options="person_async_list"
                  :normalizer="normalizer_persons"
                  :async="sync_person"
                   @select="select_user"
                  :loadOptions="load_persons"
                  :placeholder="$t('searchCustomer')"
              />
            </CCol>
            <CCol>
              <date-picker
                  :label="$t('components.startDate')"
                  v-model="start_date"></date-picker>
            </CCol>
            <CCol>
              <date-picker
                  :label="$t('components.endDate')"
                  v-model="end_date"></date-picker>
            </CCol>
            <CCol col="1">
              <CButton @click="load_data" color="dark"
                       size="sm">
                <CIcon size="sm" name="cil-zoom"/>
              </CButton>
            </CCol>
          </CRow>

          <CCardBody :id="body_id" >
            <CDataTableFixed
                :items="items_customer"
                :fields="fields_one_person"
                :items-per-page="200"
                hover
                :height="get_pagination? '280px' : ''"

                border
                :pagination="get_pagination"
                striped
            >
              <template #row_id="{item,index}">

                <td :style="get_style(item)">
                  <p class="text-center">{{ index + 1 }}</p>

                </td>

              </template>

              <template #amount="{item}">
                <td :style="get_style(item)+'text-align:right'">
                  <p style="text-align:right">{{ get_currency(item.amount) }}</p>
                </td>
              </template>
              <template #docDate="{item}">
                <td :style="get_style(item)">
                  <p v-if="item.personAccountId!=0">{{ get_date(item.docDate) }}</p>
                  <p v-else></p>
                </td>
              </template>
              <template #amountNegetive="{item}">
                <td :style="get_style(item)+'text-align:right'">
                  <p style="text-align:right">{{ get_currency(item.amountNegetive) }}</p>
                </td>
              </template>
              <template #balanceBefore="{item}">
                <td :style="get_style(item)+'text-align:right'">
                  <p  style="text-align:right" v-if="item.balanceBefore!=null">{{get_currency(item.balanceBefore)}}</p>
                </td>
              </template>
<!--              <template #accBalance="{item}">-->
<!--                <td :style="get_style(item)+'text-align:right'">-->
<!--                  <p v-if="item.amount>item.amountNegetive" style="text-align:right">{{ get_currency(item.accBalance) }}</p>-->
<!--                  <p v-else style="text-align:right">{{ get_currency(item.accBalanceNegetive) }}</p>-->
<!--                </td>-->
<!--              </template>-->
              <template #accBalance="{item}">
                <td>
                  <p style="text-align:right">{{ get_currency(item.accBalance) }}</p>
                </td>
              </template>
              <template #accBalanceNegetive="{item}">
                <td :style="get_style(item)+'text-align:right'">
                  <p>{{ get_currency(item.accBalanceNegetive) }}</p>
                </td>
              </template>

              <template #kardexAccTypeTitle="{item}">
                <td :style="get_style(item)">
                  <p v-if="item.personAccountId==0" style="text-align: end">{{ item.statusTitle }}</p>
                  <p v-else >{{ item.statusTitle }} - {{item.summary}}</p>
                </td>
              </template>

              <template #masterId="{item}">
                <td  :style="get_style(item)">
                  <a v-if="item.personAccountId!=0" href="javascript:void(0)" class="text-primary" v-on:click="goToDocuments(item)">
                    {{ item.masterCode }}
                  </a>
                  <a v-if="item.payDocCode!=null" href="javascript:void(0)" class="text-primary"
                     v-on:click="goToAccountingDocPay(item)">
                    - {{ item.payDocCode }}
                  </a>

                  <a v-if="item.accNo!=null" href="javascript:void(0)" class="text-primary"
                     v-on:click="goToAccountingDoc(item)">
                    - {{ item.accNo }}
                  </a>
                </td>

              </template>

              <template #summary="{item}">
                <td>
                  <p v-if="item.summary != 'null'">{{ item.summary }}</p>
                </td>

              </template>

              <template #operation="{item}">
                <td :style="get_style(item)">
                  <CButton
                      class="m-1"
                      color="primary"
                      variant="outline"
                      square
                      :title="$t('buttons.edit')"

                      size="sm"
                      @click="goEditPerson(item)"
                  >
                    <CIcon name="cil-pencil"/>
                  </CButton>
                  <CButton class="m-1"
                           color="success"
                           variant="outline"
                           square
                           size="sm"
                           :title="$t('buttons.documents')"
                           @click="goToDocuments(item)"
                  >
                    <CIcon name="cil-list-rich"/>
                  </CButton>

                </td>
              </template>


              <template #sumExistanceP="{item}">
                <td>
                  <p v-if="item.sumExistance>0">{{ item.sumExistance }}</p>
                  <p v-else>0</p>
                </td>
              </template>
              <template #sumExistanceN="{item}">
                <td>
                  <p v-if="item.sumExistance<=0">{{ Math.abs(item.sumExistance) }}</p>
                  <p v-else>0</p>

                </td>
              </template>
              <template #sumAmountP="{item}">
                <td>
                  <p v-if="item.sumAmount>0">{{ item.sumAmount }}</p>
                  <p v-else>0</p>

                </td>
              </template>

              <template #sumAmountN="{item}">
                <td>
                  <p v-if="item.sumAmount<=0">{{ Math.abs(item.sumAmount) }}</p>
                  <p v-else>0</p>
                </td>
              </template>


              <template #caption>
                <tr class="total-table">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>{{ $t('totalCirculation') }}</td>
                  <td>{{ get_currency(get_sum_debtor(items_customer,'amountNegetive')) }}</td>
                  <td>{{ get_currency(get_sum_credetor(items_customer,'amount')) }}</td>
                  <td >{{ get_currency(parseFloat(items_customer.filter(x=>x.personAccountId==0)[0].accBalance)+get_sum_credetor(items_customer,'amountNegetive') - get_sum_debtor(items_customer,'amount'))  }}</td>


                </tr>

              </template>
            </CDataTableFixed>

          </CCardBody>

        </CCard>
      </CCol>
    </CRow>
    <div v-show="false" :id="header_id"  style="margin-right: 50px;margin-left: 50px;margin-bottom: 30px">
      <CCardHeader>
        <CRow>

          <CCol sm="4" md="4" style="text-align: right">

          </CCol>
          <CCol sm="4" md="4" style="text-align: center">
            <h6>{{$t('customerBill')}}</h6>
          </CCol>
          <CCol sm="4" md="4" style="text-align: left">
          </CCol>
        </CRow>
        <CRow style="background-color: rgba(249,246,217,0.28);direction: rtl">
          <CCol v-if="$i18n.locale=='en'" col="4">
            <table>
              <tr >
                <td style="font-weight: bold;text-align: left"> {{get_date(start_date)}}</td>
                <td class="pl-1 pr-1"> :</td>
                <td style="font-weight: bold;text-align: right">{{$t('FromDate')}}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;text-align: left">{{get_date(end_date)}}</td>
                <td class="pl-1 pr-1"> :</td>
                <td style="font-weight: bold;text-align: right">{{$t('UpToDate')}}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;text-align: left">{{get_date(get_today())}}</td>
                <td class="pl-1 pr-1"> :</td>
                <td style="font-weight: bold;text-align: right">{{ $t('PreparedDate') }}</td>
              </tr>

            </table>

          </CCol>
          <CCol v-if="$i18n.locale=='fa'" style="direction: initial" col="3">
            <table>
              <tr >
                <td style="font-weight: bold;text-align: right"> {{get_date(start_date)}}</td>
                <td class="pl-1 pr-1"> :</td>
                <td style="font-weight: bold">{{ $t('FromDate') }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;text-align: right">{{ get_date(end_date) }}</td>
                <td class="pl-1 pr-1"> :</td>
                <td style="font-weight: bold">{{ $t('UpToDate') }}</td>
              </tr>
              <tr>
                <td style="font-weight: bold;text-align: right">{{get_date(get_today())}}</td>
                <td class="pl-1 pr-1"> :</td>
                <td style="font-weight: bold">{{ $t('PreparedDate') }}</td>
              </tr>
            </table>
          </CCol>
          <CCol col="2" v-if="$i18n.locale=='en'"></CCol>
          <CCol col="3" v-if="$i18n.locale=='fa'"></CCol>
          <CCol col="6" class="text-left">

            <div>
              <table>
                <tr>
                  <th style="width: 400px;padding-top: 0;text-align: end" class="pr-2 pl-2">
                    <h6 class="m-0" style="font-weight: bold">{{
                        bissiness_profile.businessName
                      }}</h6>
                    <p class="m-0" style="direction: ltr;text-align: left;">{{ company_address }}</p>
                    <!--                                                <p class="m-0">{{ bissiness_profile.vatNumber }}</p>-->
                    <p class="m-0">{{ phone_objects[0].phone }}</p>
                    <p class="m-0">{{ email_objects[0].phone }}</p>
                  </th>
                  <th width="100px">
                    <CImg :src="get_logo()" width="100px" height="50px"/>
                  </th>
                </tr>
              </table>
            </div>

          </CCol>
        </CRow>
        <hr class="p-0 m-0" style="border-top: 1px solid rgb(0,0,0);">
      </CCardHeader>

      <CCol>
<!--        <CRow style="justify-content:center">-->
<!--          <strong style="font-size: large">{{get_bussiness_name()}}</strong>-->
<!--        </CRow>-->

<!--        <CRow style="justify-content:center">-->
<!--          <strong>{{$t('router.listCustomers')}}</strong>-->
<!--        </CRow>-->
<!--        <CRow>-->
<!--          <CCol >-->
<!--            <label>{{$t('FromDate')}} {{get_date(start_date)}}</label>-->
<!--          </CCol>-->
<!--          <CCol style="text-align:center" >-->
<!--            <label >{{$t('UpToDate')}} {{get_date(end_date)}}</label>-->
<!--          </CCol>-->
<!--          <CCol style="text-align:end" >-->
<!--            <label >{{$t('PreparedDate')}} {{get_date(get_today())}}</label>-->
<!--          </CCol>-->
<!--        </CRow>-->
        <CRow>
          <CCol>
            <h6>{{ selected_person_name }}</h6>
<!--            <label v-if="selected_city!=0">{{city_items.filter(x=>x.cityId == selected_city)[0].cityName}} ,</label>-->
<!--            <label v-if="selected_district!=0">{{district_items.filter(x=>x.id == selected_district)[0].title}} ,</label>-->
<!--            <label v-if="selected_route!=0">{{route_items.filter(x=>x.id == selected_route)[0].title}}</label>-->
          </CCol>
        </CRow>
      </CCol>

    </div>
    <div v-show="false" :id="footer_id" >
      <CCardHeader>
        <CRow style="border: 1px solid #9c9c9c">


          <CCol sm="4" md="4" style="text-align: start">
            <h5>{{ $t('docCreator') }} : {{ get_user_name() }}</h5>
          </CCol>
          <CCol sm="4" md="4" style="text-align: center">
            <h2 id="pageFooter" class="pageFooter"></h2>
          </CCol>
          <CCol sm="4" md="4" style="text-align: end">
            <h2>
            </h2>
          </CCol>
        </CRow>

      </CCardHeader>

    </div>
    <CModal
        :show.sync="show_factor_detail"
        :no-close-on-backdrop="true"
        :centered="true"
        :title="$t('InventoryBill')"
        size="lg"
        color="dark"
    >
      <CCard id="printMe">
        <ShowPayReceiveDocs :doc_id="selected_doc_id"/>

      </CCard>


      <template #footer>

        <CButton
            @click="show_factor_detail = false"
            color="success"
        >{{ $t("buttons.close") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from "vue";
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import BTabs from "../../tabs/BTabs";
import ShowPayReceiveDocs from "../accounting/ShowPayReceiveDocs";

var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
export default {
  name: 'Login',
  components: {
    Treeselect,
    ShowPayReceiveDocs,

  },
  data() {
    return {
      show_factor_detail:false,
      selected_doc_id:null,

      header_id: "header_customer_one_bill" + new Date().getTime() + this.$vnode.tag,
      footer_id: "footer_customer_one_bill" + new Date().getTime() + this.$vnode.tag,
      body_id: "body_customer_one_bill" + new Date().getTime() + this.$vnode.tag,

      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      VUE_APP_Currency: localStorage.getItem('currency'),
      items_customer: [],
      items_customer_all: [],
      start_date: '',

      types_all: [],
      types_parent: [],
      selected_type_parent: 10,
      selected_type_child: 0,

      end_date: '',
      fields_one_person: [//amount amountNegetive accBalance accBalanceNegetive
        {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:5%'},
        {key: 'docDate', label: this.$t('date'), _style: 'width:10%'},
        {key: 'kardexAccTypeTitle', label: this.$t('documentType'), _style: 'width:10%'},

        {key: 'masterId', label: this.$t('reference'), _style: 'width:10%'},

        // {key: 'balanceBefore', label: this.$t('balanceBefore'), _style: 'width:10%'},
        {key: 'amountNegetive', label: this.$t('tables.debtor'), _style: 'width:10%'},
        {key: 'amount', label: this.$t('tables.creditor'), _style: 'width:10%'},
        // {key: 'accBalanceNegetive', label: this.$t('tables.debtorBalance'), _style: 'width:10%'},
        {key: 'accBalance', label: this.$t('tables.balance'), _style: 'width:10%'},
        // {key: 'statusTitle', label: this.$t('tables.documentType'), _style: 'width:10%'},
        // {key: 'kardexAccTypeTitle', label: this.$t('tables.type'), _style: 'width:10%'},
        // {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},

        // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

      ],

selected_person_name:'',

      normalizer_accounting(node) {
        return {
          id: node.id,
          label: node.accountCode + " " + node.accountName,
        }
      },
      normalizer_accounting_tafzili(node) {
        return {
          id: node.recId,
          label: node.title,
        }
      },
      load_persons({action, searchQuery, callback}) {

        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options;
            const formData = new FormData();

            formData.append('SearchTxt', searchQuery);
            var url = "GetAllPersons";

            formData.append('IsVendor', false);
            formData.append('IsWorker', false);
            formData.append('IsCustomer', true);
            formData.append('IsActive', 0);

            axios.post(url, formData, {show_pros: true}).then(function (response) {
              options = response.data.data;

              callback(null, options);

            })
                .catch(function (error) {

                  console.log(error);
                });

          })
        }
      },
      normalizer_persons(node) {
        return {
          id: node.userId,
          label:  node.personCode + " " + node.fullName ,
        }
      },
      templates_items: [],
      accounting_list: [],
      moein_list: [],
      tafsili_list: [],
      selected_person: null,
      selected_moein: null,
      selected_tafsili: null,
      collapseDuration: 0,
      person_name: '',
      status_form: 0,

      route_items: [],
      selected_route: 0,

      area_items: [],
      selected_area: 0,

      province_items: [],
      selected_province: 0,

      city_items: [],
      selected_city: 0,

      district_items: [],
      selected_district: 0,

      country_items: [],

      selected_country: 0,
      bissiness_profile: {},
      company_address: '',
      phone_objects: [{phone:""}],
      email_objects: [{phone:""}],
      website_objects: [{phone:""}],

      table_clicks:0,
      table_clicks_timer:null,
      checkbox_all_items:[],
      check_all_exit:false,
      person_async_list:[],
      sync_person:true,
    }
  }, mounted() {

    this.$root.root_validate_errors = [];
    // this.get_lists_groups();
    // this.get_types();
    // this.get_country()
    // this.get_routes()
    // this.get_all_customers()
    this.get_bussiness_profile();
    this.get_main_address();
    this.get_contact();

    this.start_date = this.get_day_before_today(1);
    this.end_date = this.get_today();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    if(this.$route.params.personId!=null){
      this.selected_type_parent = 10;
      this.sync_person = false;
      this.person_async_list = [{
        userId: this.$route.params.personId,
        personCode: this.$route.params.personCode,
        tafsiliTypeId: this.$route.params.tafsiliTypeId,
        fullName: this.$route.params.personName
      }];

      setTimeout(() => {
        this.selected_person = this.$route.params.personId;
        this.tafsiliTypeId = this.$route.params.tafsiliTypeId;
        this.get_lists();
      }, 300);
      setTimeout(() => {
        this.sync_person = true;
      }, 1000);
      this.start_date = this.$route.params.start_date;
      this.end_date = this.$route.params.end_date;
    }


    bus.$on("report_select_one_customer", (data) => {
      // alert(data);
      this.selected_type_parent = 10;
      this.sync_person = false;
      this.person_async_list= [{userId:data.item.personId,
        personCode:data.item.personCode,fullName:data.item.personName+" "+data.item.surName}];
      setTimeout(() => {
        this.selected_person = data.item.personId;
        this.selected_person_name = data.item.personCode+" "+data.item.personName;
        this.get_lists();
      }, 300);
      setTimeout(() => {
        this.sync_person = true;
      }, 1000);
      this.start_date = data.start_date;
      this.end_date = data.end_date
    });
  }, watch: {
    'check_all_exit':function(){
     if(this.check_all_exit){
       this.items_customer_all.forEach(function (val){
         this.checkbox_all_items.push(val.personId);
       });

     } else{
       this.checkbox_all_items=[];
     }
    },
    'selected_type_parent': function () {
      this.selected_person = null;
      this.items_customer=[];

          this.items_customer_all= []

          this.items_all_customer=[]

          this.items_customers_bill= []

      // if(this.selected_type_parent==10){
      //   this.body_id = 'body_customer_bill';
      //   this.header_id = 'header_customer_bill';
      // }
      // if(this.selected_type_parent==15){
      //   this.body_id = 'body_customer_all_person';
      //   this.header_id = 'header_customer_all_person';
      //
      // }
      // if(this.selected_type_parent==13){
      //   this.body_id = 'body_all_customer';
      //   this.header_id = 'header_all_customer';
      //
      // }
      // if(this.selected_type_parent==14){
      //   this.body_id = 'body_customers_bill';
      //   this.header_id = 'header_customers_bill';
      //
      // }
    },
    'selected_province': function () {
      this.get_cities();
    },
    'selected_city': function () {
      this.get_districts();
    },
    'selected_district': function () {
      this.get_areas();
    },
    'selected_country': function () {
      this.get_provinces();
    },
  },
  methods: {
    goToAccountingDocPay(item) {
      this.show_factor_detail = true
      this.selected_doc_id = item.payDocId
    },
    goToAccountingDoc(item) {
      window.open('/dashboard/accounting/show-accounting-doc/'+item.payAccId)
    },
    select_user(node, instance) {
    this.selected_person_name = node.fullName+" "+node.personCode;

    },

    get_style(item) {
      var color = '#56ff42';
      if(item.personAccountId==0){
        // return 'backgroundColor: \'#56ff42\'';
        return {

          backgroundColor: color

        }
      }

    },
    get_sum_debtor(list,field) {
      var sum = 0;
      list.forEach((val) => {
        val[field] = val[field].toString().replace(/,/g, '');
        sum += parseFloat(val[field]);
      })
      return sum;
    },
    get_sum_credetor(list,field) {
      var sum = 0;
      list.forEach((val) => {
        val[field] = val[field].toString().replace(/,/g, '');

        sum += parseFloat(val[field]);
      })
      return sum;
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.unitName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = item.image;
      this.status_form = item.id;
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, edit_sale_method(item) {
      this.selected_method = item.saleMethodId;
      this.selected_person = item.userId;
      this.saleMethodModal = true;

    },

    load_data() {

        this.get_lists();

    },
    get_lists() {
      var self = this;


      const formData = new FormData();

      var url = "GetPersonAccountsByPersonId_New";
//tasiliType 0 =>Other, 1=> Personal, 2=> Customers, 3=> Sellers, 4=> Persons, 5=> Bank,, 6=> CashBox,

      formData.append('TafsiliType',2);
      formData.append('id', this.selected_person);
      formData.append('PartyId', this.selected_person);
      formData.append('ParentId', this.selected_type_parent);
      formData.append('ChildId', this.selected_type_parent);
      formData.append('FromDate', this.start_date);
      formData.append('ToDate', this.end_date);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;
        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer = content_data.data.personAccountItems;

          self.items_customer.forEach(function (val,index) {
            if(index==0) {
              val.reminingBefore = 0;
              if(val.natureId==0 && self.items_customer[index+1]!=null){
                val.natureId = self.items_customer[index+1].natureId;
              }
              // val.accBalance = val.accBalance
            }else{
              val.reminingBefore = self.items_customer[index-1].accBalance;

              if(val.natureId==2){
                val.accBalance = parseFloat(val.reminingBefore) +  parseFloat(val.amount);
                // val.accBalanceFinal =val.accBalance
                if(val.amount>0){
                  val.amountNegetive=Math.abs(val.amount);
                  val.amount=0;

                }else{
                  val.amount=Math.abs(val.amount);
                  val.amountNegetive=0;
                }
              }else{

                val.accBalance = parseFloat(val.reminingBefore)   + parseFloat(val.amount);
                if(val.amount<0){
                  val.amountNegetive=0;
                  val.amount=Math.abs(val.amount);

                }else{
                  val.amountNegetive=Math.abs(val.amount);
                  val.amount=0;

                }
              }
            }

          })

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goEditPerson(item) {

      this.$router.push({path: '/dashboard/users/edit-user/' + item.userId});

    },
    goToDocuments(item) {
// statusid 3 sales

      if(item.statusId>=1 && item.statusId<=6) {
        // this.$router.push({path: '/dashboard/documents/show/' + item.masterId});
        window.open('/dashboard/documents/show/' + item.masterId)
      }
      //
      // if(item.statusId==10 ) {
      //   //receive cheque
      //   this.$router.push({path: '/dashboard/documents/show/' + item.masterId});
      // }
      if(item.statusId==8 || item.statusId==7) {
        //receive cash
        this.selected_doc_id=item.masterId

        this.show_factor_detail=true
        // this.$router.push({path: '/dashboard/documents/show/' + item.masterId});
      }

    },
    get_bussiness_profile() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.bissiness_profile_id);


      axios.post('GetProfileById', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bissiness_profile = content_data.data
          self.previewImage = localStorage.getItem("api_address") + "/images/Business/" + content_data.data.logo
          localStorage.setItem("app_logo", localStorage.getItem("api_address") + "/images/Business/" + content_data.data.logo)
          document.getElementById("logo_image").src = localStorage.getItem("app_logo")
        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_main_address() {
      var self = this;

      const formData = new FormData();


      axios.post('GetAddressById', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          // self.main_address = content_data.data.data
          self.main_address = content_data.data

          if (self.$i18n.locale == 'fa') {
            self.company_address = self.main_address.cityName + " " + self.main_address.street + " " + self.main_address.houseNO + " " + self.main_address.postCode;

          } else {
            self.company_address = self.main_address.houseNO + " " + self.main_address.street + " " + self.main_address.cityName + " " + self.main_address.postCode;

          }


        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_contact() {
      var self = this;

      const formData = new FormData();

      axios.post('GetContactById', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          // self.main_address = content_data.data.data
          self.phone_objects = [{phone_type: 19, phone: '', row_id: 1}]
          self.email_objects = [{phone_type: 19, phone: '', row_id: 1}]
          self.website_objects = [{phone_type: 19, phone: '', row_id: 1}]
          if (content_data.data.length) {
            self.phone_objects = []
            self.email_objects = []
            self.website_objects = []

          }
          content_data.data.forEach((val) => {
            if (val.contactType == 1) {
              self.phone_objects.push({phone: val.contactText});
            }
            if (val.contactType == 2) {
              self.email_objects.push({phone: val.contactText});

            }
            if (val.contactType == 3) {
              self.website_objects.push({phone: val.contactText});

            }


          });
        } else {
          // self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}

</script>
